import type { ReactNode } from 'react';
import { TonConnectUIProvider } from '@tonconnect/ui-react';

const MANIFEST_URL = `${typeof window !== 'undefined' ? window.location.origin : 'https://vbbplay.com'}/tonconnect-manifest.json`;

/** Thin wrapper so Cashier can mount TonConnect only when the feature is reachable. */
export function TonConnectShell({ children }: { children: ReactNode }) {
  return (
    <TonConnectUIProvider manifestUrl={MANIFEST_URL}>
      {children}
    </TonConnectUIProvider>
  );
}
